import { createContext, useContext, useEffect } from 'react'

export interface HeaderState {
  title: string
  subtitle?: string
}

export interface HeaderContextValue extends HeaderState {
  setHeader: (h: HeaderState) => void
}

export const PageHeaderContext = createContext<HeaderContextValue | null>(null)

/** Lu par la topbar du shell. */
export function usePageHeaderValue(): HeaderState {
  const ctx = useContext(PageHeaderContext)
  return ctx ?? { title: 'Amine Taxi' }
}

/** Appelé par chaque page pour alimenter la topbar. */
export function usePageHeader(title: string, subtitle?: string) {
  const ctx = useContext(PageHeaderContext)
  useEffect(() => {
    ctx?.setHeader({ title, subtitle })
  }, [ctx, title, subtitle])
}
